<template>
  <pie-chart
    :titulo="titulo"
    :fonte="fonte"
    :dados="indicacoesDesempenhoSeries"
    :dados-complementares="resultadosResponsabilidadeSubSeries"
    class="chart"
    :is-get-svg="isGetSvg"
    @svg="(value) => $emit('svg', value)"
  />
</template>

<script>
import PieChart from '@/components/chart/PieChart';
import { mapState } from 'vuex';
import _ from 'lodash';

export default {
  name: 'PieChartIndicacoesDesenvolvimento',

  components: {
    PieChart,
  },

  props: {
    titulo: {
      type: String,
      required: true,
    },
    indicacoesDesempenho: {
      type: Array,
      required: true,
    },
    comSubPiechart: {
      type: Boolean,
      required: true,
    },
    fonte: {
      type: String,
      required: true,
    },
    isGetSvg: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    ...mapState({
      tiposComplexidade: (state) => state.desempenho.tiposComplexidade,
      isUmaUnidade: (state) => state.desempenho.isUmaUnidade,
    }),

    indicacoesDesempenhoSeries() {
      let d = this.tiposComplexidade.map((tipo) => ({
        name: tipo.descricao,
        y: this.indicacoesDesempenho.filter((i) => i.complexidadeResponsabilidade.nome === tipo.nome).length,
        color: tipo.color,
      }));

      if (this.comSubPiechart) {
        d = d.map((item) => ({
          ...item,
          drilldown: item.y > 0 ? item.name : null,
        }));
      }

      return [{ name: 'Complexidades', data: d }];
    },

    resultadosResponsabilidadeSubSeries() {
      if (!this.comSubPiechart) {
        return [];
      }

      const d = this.tiposComplexidade.map((tipo) => ({
        id: tipo.descricao,
        name: tipo.descricao,
        data: _(this.indicacoesDesempenho)
          .filter((i) => i.complexidadeResponsabilidade.nome === tipo.nome)
          .groupBy('siglaUnidade')
          .map((v, k) => ({
            name: k,
            y: v.length,
          }))
          .value(),
      }));

      return d;
    },
  },
};
</script>
